<template>
  <div class="mt-2 flex overflow-hidden flex-grow gap-2">

    <!-- main content (left side) -->
    <div class="flex flex-col overflow-auto flex-grow gap-2">

      <!--project/magazine bar  -->
      <div class="w-full flex bg-primary gap-2 overflow-auto shrink-0">
        <CGoBack/>
        <table class="flex-grow">
          <tr>
            <!-- project -->
            <td><span class="font-bold">Projekt:</span></td>
            <td>
              <CreatProjekt/>
            </td>
          </tr>
          <tr>
            <!-- magazine -->
            <td><span class="font-bold">Magazine:</span></td>
            <td>
              <CEditMagazine :magazine-id="magazineId"/>
            </td>
          </tr>
        </table>
      </div>

      <!-- main content (center) -->
      <div class="flex flex-grow overflow-hidden gap-2">


        <!-- market list -->
        <div class="flex flex-col gap-2 " v-if="showMarket">

          <!-- toolbar for market selection -->
          <div class="flex bg-primary">
            <div @click="selectOreNavigate" class="w-1/3 py-1 text-center hover:bg-trader-blue hover:text-white"
                 title="Navigation oder Selektion"
                 :class="navigate ? 'bg-trader-blue text-white' : 'bg-trader-green text-black'">
              <i class="fa-solid fa-arrow-pointer"></i>
            </div>
            <div @click="selectAllMarketsWithSameTemplateId" title="Alle Märkte mit dem gleichen Template auswählen"
                 class="w-1/3 py-1 text-center hover:bg-trader-blue hover:text-white">
              <i class="fa-solid fa-list-check"></i>
            </div>
            <div @click="selectAllMarkets" class="w-1/3 py-1 text-center hover:bg-trader-blue hover:text-white"
                 title="Alle Märkte auswählen">
              <i class="fa-solid fa-check-double"></i>
            </div>
          </div>

          <!-- market list -->
          <div class="gap-2 flex flex-col w-20 h-full text-center overflow-auto">
            <div class="p-1 flex  hover:bg-trader-blue justify-between hover:text-white cursor-pointer"
                 :data-ui="market?.name"
                 v-for="market in marketList"
                 :key="market.marketId" @click="selectMarketId(market.marketId, market.templateId)"
                 :class="{  'bg-trader-blue text-white': selectedMarketIds.length == 0  ? selectedMarketId == market.marketId : selectedMarketIds.includes(market.marketId),
                  'bg-trader-dark-gray': selectedMarketIds.length == 0 ? selectedMarketId != market.marketId : !selectedMarketIds.includes(market.marketId)}">
              <span class="h-full p-1"
                    :style="`background-color: ${colors[templateIds.indexOf(market.templateId)]}`"></span>
              <span class="w-full  p-1">{{ market?.name }}</span>
            </div>
          </div>
        </div>

        <!-- grid -->
        <div class="flex flex-grow  items-center flex-col" v-if="loadPageID">
          <PageGrid :editMode="false" :pageID="loadPageID" :on-click-placeholder="onClickPlaceholder"/>
        </div>


        <!-- sidebar from main content-->
        <div class="flex flex-col overflow-auto gap-2 w-[320px]" v-if="loadPageID !== 0">
          <CEditPurchaser v-if="hasSameIds(selectedTemplateIds)" :pageId="loadPageID" :filtered-pages="filteredPages"
                          :selected-placeholder="selectedPlaceholder" :market-ids="selectedMarketIds"/>
          <div class="w-full my-2 h-[400px] text-center items-center justify-center flex bg-trader-gray " v-else>
            <span class="">Einkaufbereiche können nur hinzugefügt werden wenn keine unterschiedlichen Templates ausgewählt sind </span>
          </div>
          <button class="w-full bg-trader-gray hover:bg-trader-blue hover:text-white font-bold py-2"
                  data-ui="button-open-grid-settings" @click="openRaster">Raster Öffnen
          </button>
          <CChangePageTemplate :page-id="loadPageID" :pages="filteredPages" :show-market="showMarket"
                               :market-ids="selectedMarketIds"/>
          <CEditPageName :name="pageName" :page-id="loadPageID"/>
        </div>

      </div>

      <!-- content (bottom page view) -->
      <div class="flex flex-col gap-2">

        <!-- Purchaser list -->
        <div class="w-full bg-trader-dark-gray min-h-[20px] gap-2 flex overflow-x-auto">
            <span v-for="team in pageTeams" class=" font-bold rounded px-2 flex-shrink"
                  :style="`background-color: ${team.color}; color: ${getBackgroundColor(team.color)}`"
                  :title="team.tag + ' ' + team?.name"
                  :data-ui="'assigned-ekb-' + team.tag"> {{ team.tag }}
            </span>
        </div>

        <!-- Page list -->
        <div class="flex  ">
          <div class="overflow-x-auto flex-grow ">
            <draggable v-if="filteredPages?.length > 0" v-model="filteredPages" :animation="200" class="flex  gap-2"
                       @update="updatePagePositions"
                       :options="{
                            animation: 200,
                            scroll: true,
                            scrollSensitivity: 400,
                            scrollSpeed: 10,
                          }" :disabled="!allowPageSwap">
              <div v-for="page in filteredPages" :key="page.pageId"
                   :data-ui="'select-page-'+page.pagePosition+''"
                   class="  items-center justify-center flex flex-wrap  bg-trader-gray">
                <div class="flex ">
                  <!-- page teams icons-->
                  <div class="flex flex-col justify-start overflow-y-auto w-full max-h-[100px]"
                       @click="showPurchaseTitle = !showPurchaseTitle">
                    <div v-for="team in page.team"
                         class="mb-0.5 px-1 font-bold text-[8pt] rounded-bl rounded-tl"
                         :class="!showPurchaseTitle ? 'min-h-[10px] min-w-4' : ''"
                         :title="team.tag + ' ' + team?.name"
                         :style="`background-color: #${team.color}; color: ${getBackgroundColor(team.color)}`">
                      <span v-if="showPurchaseTitle">{{ team.tag }}</span>
                    </div>
                  </div>

                  <!-- gray background -->
                  <div class=" min-w-[70px] max-w-[70px]  border-2 border-trader-dark-gray">

                    <div class="w-full pb-0.5 ">
                      <!-- Bestehender Inhalt -->
                      <div class=" w-full h-[80px] flex flex-col " :data-ui="'page' + page.pagePosition"
                           draggable="true"
                           @click="selectPage(page.pageId, page?.name,page.pagePosition, page.marketId )">
                        <div class=" w-full h-full relative flex items-center justify-center cursor-pointer "
                             :title=" 'Name: ' + page?.name">
                          <div class="z-10 w-full h-full absolute"></div>
                          <ShowPreview :pageId="page.pageId" :showPages="false" class="w-full h-full"/>
                        </div>
                      </div>
                    </div>

                    <div
                        :class="{ 'bg-trader-blue ': page.pageId === loadPageID, 'bg-trader-gray': page.pageId !== loadPageID }">
                      <CEditPage :page-id="page.pageId" :page="page" :markt="marketList" :show-markt="showMarket"/>
                    </div>
                  </div>
                </div>

              </div>
            </draggable>
          </div>

          <CAddPage :magazine-id="magazineId"/>
        </div>
      </div>
    </div>

    <Sidebar/>
  </div>
</template>

<script>
import {gql} from "@apollo/client/core"; //import Draggable from "vue3-draggable";
import {VueDraggableNext} from "vue-draggable-next"; //import draggable from 'vuedraggable';
import apolloClient from "../../../apolloClient";
import PageGrid from "@/components/PageGrid/PageGrid.vue";
import Sidebar from "@/components/Administration/Sidebar.vue";
import CreatProjekt from "@/components/Administration/Project/CreatProjekt.vue";
import ShowPreview from "@/components/Preview/ShowPreview.vue";
import {eventBus} from "@/application/EventBus";
import SignalBus from "@/application/SignalBus";
import changeTemplate from "@/components/Dialogs/ChangeTemplate.vue";
import Spinner from "@/components/Base/Spinner.vue";
import CGoBack from "@/components/Administration/CGoBack.vue";
import CChangePageTemplate from "@/components/Administration/Magazine/CChangePageTemplate.vue";
import CEditPurchaser from "@/components/Administration/Magazine/CEditPurchaser.vue";
import CAddPage from "@/components/Administration/Magazine/CAddPage.vue";
import CEditPageName from "@/components/Administration/Magazine/CEditPageName.vue";
import CEditPage from "@/components/Administration/Magazine/CEditPage.vue";
import {useRoute} from "vue-router";
import router from "@/router";
import CEditMagazine from "@/components/Administration/Magazine/CEditMagazine.vue";


export default {
  components: {
    CEditMagazine,
    ShowPreview,
    CEditPageName,
    CAddPage,
    CEditPurchaser,
    CChangePageTemplate,
    CGoBack,
    CEditPage,
    CreatProjekt,
    PageGrid,
    Sidebar,
    draggable: VueDraggableNext,
    SignalBus,
    changeTemplate,
    Spinner
  },
  data() {
    return {
      selectionModi: 'navigation',
      magazineId: 0,
      route: '',
      projectId: '',
      pagesData: {pages: []},
      pageName: '',
      pageTeams: [],
      pageID: 0,
      list: [],
      borderActive: false,
      loadPageID: 0,
      selectedPlaceholder: null,
      marketList: [],
      selectedMarketId: 2,
      selectedMarketIds: [],
      pages: [],
      filteredPages: [],
      pagePosition: 0,
      showMarket: false,
      showPurchaseTitle: true,
      isLoading: false,
      editPageName: false,
      accordionIndex: 0,
      marketId: 0,
      templateIds: [],
      selectedTemplateIds: [],
      selectMarkets: true,
      navigate: true,
      allowPageSwap: true,
      loadPageSwapIng: false,
      colors: [
        "#FF5733", // kräftiges Rot-Orange
        "#33FF57", // kräftiges Grün
        "#3357FF", // kräftiges Blau
        "#FF33A6", // kräftiges Pink
        "#A6FF33", // kräftiges Gelb-Grün
        "#33FFA6", // kräftiges Türkis
        "#A633FF", // kräftiges Lila
        "#FF8633", // kräftiges Orange
        "#33A6FF", // kräftiges Hellblau
        "#FF33FF", // kräftiges Magenta
        "#FFD733", // kräftiges Gelb
        "#FF3333", // kräftiges Rot
        "#33FFD7", // kräftiges Aqua
        "#D733FF", // kräftiges Violett
        "#FF5733", // kräftiges Hellrot
        "#33FF33", // kräftiges Limettengrün
        "#5733FF", // kräftiges Indigo
        "#FF33D7", // kräftiges Fuchsia
        "#33D7FF", // kräftiges Cyan
        "#D7FF33"  // kräftiges Neongelb
      ],
    };
  },
  methods: {
    hasSameIds(ids) {
      if (!ids.length) return true; // Falls keine IDs vorhanden sind, wird true zurückgegeben
      const firstId = ids[0];
      return ids.every(id => id === firstId);
    },
    selectOreNavigate() {
      this.navigate = !this.navigate;
    },
    selectAllMarketsWithSameTemplateId() {
      this.marketList.forEach(market => {
        this.selectedTemplateIds.forEach(templateId => {
          if (market.templateId === templateId) {
            this.selectedMarketIds.push(market.marketId);
          }
        });
      });
    },
    selectAllMarkets() {

      // wenn selectedMarketIds leer ist, dann füge alle marketIds hinzu wenn nicht, dann leere selectedMarketIds
      if (this.selectedMarketIds.length === 0) {
        this.marketList.forEach(market => {
          this.selectedMarketIds.push(market.marketId);
        });
      } else {
        this.selectedMarketIds = [];
      }
    },
    async getShoppingSectionsFromPage() {
      await this.getPages();
      try {
        const response = await apolloClient.query({
          query: gql`
        query getShoppingSectionsFromPage($pageId: Int!) {
          getShoppingSectionsFromPage(pageId: $pageId) {
            pageID
            teams {
                id
                tag
                name
                color
            }
          }
        }
      `,
          variables: {
            pageId: this.loadPageID
          }
        });
        if (response.data.getShoppingSectionsFromPage) {

          const data = response.data.getShoppingSectionsFromPage;
          this.pageTeams = data.teams;

        }
      } catch (error) {
        console.error("Fehler beim Abrufen der Pages:", error);
      }
    },
    loadEkbSections() {
      this.isLoading = true;
      // Simuliere das Laden der Daten
      setTimeout(() => {
        this.isLoading = false;
        // Logik zum Laden der Einkaufsbereiche
      }, 3000); // Simuliert eine Ladezeit von 2 Sekunden
    },
    openRaster() {
      eventBus.openModal(PageGrid, {
        pageId: this.loadPageID
      }, {
        halfSize: true
      });

      //fullSize: true
    },
    getBackgroundColor(teamColor) {
      if (teamColor === undefined) {
        return '#000000';
      }
      // Berechne die Helligkeit der Schriftfarbe
      const color = teamColor?.startsWith('#') ? teamColor.substring(1) : teamColor;
      const r = parseInt(color.substr(0, 2), 16);
      const g = parseInt(color.substr(2, 2), 16);
      const b = parseInt(color.substr(4, 2), 16);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      // Wähle die Hintergrundfarbe basierend auf der Helligkeit
      return brightness > 125 ? '#000000' : '#FFFFFF';  // Dunkler Hintergrund für helle Schrift und umgekehrt
    },
    selectMarketId(marketId, templateId) {
      let pagePosition = 1;
      if (this.navigate) {
        this.selectedMarketId = marketId;
        this.selectedTemplateIds = [];
        this.selectedTemplateIds.push(templateId)
        this.selectedMarketIds = [];
      } else {
        this.selectedTemplateIds.push(templateId)
        if (this.selectedMarketIds.includes(marketId)) {
          this.selectedMarketIds = this.selectedMarketIds.filter(id => id !== marketId);
          this.selectedTemplateIds = this.selectedTemplateIds.filter(id => id !== templateId);
        } else {
          this.selectedMarketIds.push(marketId)
        }
      }
      this.filteredPages.forEach(page => {
        if (page.pageId === this.loadPageID) {
          pagePosition = page.pagePosition;
        }
      });
      //this.selectedPlaceholder = null;
      router.push(`/administration/${this.accordionIndex}/page/${this.projectId}/${this.magazineId}/${pagePosition}/${marketId}`)
      this.filterPagesByMarketId();

    },
    onClickPlaceholder(item) {
      this.selectedPlaceholder = item?.virtualId;
    },
    async updatePagePositions() {
      try {
        this.loadPageSwapIng = true;
        this.allowPageSwap = false;
        this.pageData = this.filteredPages.map((item, index) => ({
          pageID: item.pageId,
          position: String(index),
        }));
        const mutation = gql`
          mutation editPage($page: [PagePosition!]!) {
            editPage(page: $page) {
              success
            }
          }
        `;

        const variables = {
          page: this.pageData
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        await this.getPages();
      } catch (error) {
        console.error("Daten konnten nicht geUpdatet werden", error);
      }finally {
        this.loadPageSwapIng = false;
        this.allowPageSwap = true;
      }
    },
    async getPages() {
      const response = await apolloClient.query({
        query: gql`
        query pages($filter: QueryFilter) {
          pages(filter: $filter) {
            pageId
            lock
            marketId
            magazineId
            pagePosition
            name
            team{
              id
              tag
              name
              color
            }

          }
        }
      `,
        variables: {
          filter: {
            magazineId: this.magazineId,
            marketId: this.selectedMarketId
          }
        }
      });
      try {
        let pagePosition = this.$route.params.pagePosition;
        let marketId = this.$route.params.marketId;
        this.pages = response.data.pages
        this.pages.forEach(page => {
          if (page.pagePosition == pagePosition && page.marketId == marketId) {
            this.loadPageID = page.pageId;
          }
        });
        this.showMarket = this.pages[0].marketId !== 0;
        this.filterPagesByMarketId()
      } catch (error) {
        console.error("Fehler beim Abrufen der Pages:", error);
      }
    },
    filterPagesByMarketId() {
      if (this.showMarket) {
        this.filteredPages = this.pages.filter(page => page.marketId == this.selectedMarketId);
        this.filteredPages.forEach(page => {
          if (page.pagePosition === this.pagePosition) {
            this.pageTeams.push(page.team)
            this.loadPageID = page.pageId
            this.getShoppingSectionsFromPage()
          }
        });
      } else {
        this.filteredPages = this.pages
      }
    },
    async getMarkets() {
      const query = gql`
    query getMarketsInfo($magazineId: Int!, $pagePosition: Int!) {
      getMarketsInfo(magazineId: $magazineId, pagePosition: $pagePosition) {
        marketId
        name
        description
        isActive
        templateId
      }
    }
  `;
      const variables = {
        magazineId: this.magazineId,
        pagePosition: this.pagePosition
      };
      try {
        const {data} = await apolloClient.query({query, variables});
        this.marketList = data.getMarketsInfo; // Aktualisierte Datenzuordnu// ng

        this.marketList.forEach(market => {
          // wenn market.templateId nicht in templateIds ist, dann füge es hinzu
          if (!this.templateIds.includes(market.templateId)) {
            this.templateIds.push(market.templateId);
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    selectPage(id, name, pagePosition, marketId) {
      this.loadPageID = id;
      this.pageName = name;
      this.getShoppingSectionsFromPage();
      router.push(`/administration/${this.accordionIndex}/page/${this.projectId}/${this.magazineId}/${pagePosition}/${marketId}`)

    },
    getRoute() {
      let route = useRoute();
      this.fullRoute = route.fullPath;
      return this.fullRoute;
    },
    getOnReload() {
      this.loadEkbSections();
      this.route = this.getRoute();
      SignalBus.connect(this, "delete-page", this.deletePage);
      this.projectId = this.$route.params.projectId;
      this.magazineId = this.$route.params.magazineId;
      this.accordionIndex = this.$route.params.accordionIndex;
      this.pagePosition = this.$route.params.pagePosition;
      this.getPages();
      this.getMarkets();
      SignalBus.connect(this, "reloadPages", this.getPages);
      SignalBus.connect(this, 'reload-save-grid', this.getPages);
      SignalBus.connect(this, "project-reload-purchaser-page", this.getMarkets);
      SignalBus.connect(this, "project-reload-purchaser-page", this.getShoppingSectionsFromPage);
    },
  }
  ,
  mounted() {
    this.getOnReload();
  },
  beforeUnmount() {
    SignalBus.disconnectAllFromParent(this);
  },
  created() {
    this.getOnReload();
    if (this.$route.params.marketId > 0) {
      
      this.selectedMarketId = this.$route.params.marketId;
      
      //this.selectedMarketIds = [this.$route.params.marketId];
    }
  },
  watch: {
    '$route.params': {
      handler: function (params) {
        this.magazineId = params.magazineId;
        this.projectId = params.projectId;
        this.accordionIndex = params.accordionIndex;
        this.pagePosition = params.pagePosition;
        this.getPages();
        this.getMarkets()
      },
    },
  },
};
</script>
